"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultFailure = void 0;
const react_1 = __importDefault(require("react"));
const InlineMessage_1 = require("../../inline-message/InlineMessage");
const Heading_1 = require("../../heading/Heading");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const ResultFailure = () => react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Heading_1.HeadingSmall, null,
        react_1.default.createElement(InlineMessage_1.InlineError, { text: "Unable to set your Smart pricing" })),
    react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
    react_1.default.createElement(Paragraph_1.Paragraph, null, "We\u2019ve encountered an error when trying to set-up your smart pricing. Please try again."),
    react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
    react_1.default.createElement(Paragraph_1.Paragraph, null, "If the issue keeps happening, it may be because Smart pricing is not yet available in your area."));
exports.ResultFailure = ResultFailure;
//# sourceMappingURL=ResultFailure.js.map